export default __webpack_public_path__ + "media/images/home/slide_2025_ryukogo_sm-ec699f80ceb749e5854539ba4ded9d29.png";